import { NODE_ENV } from '@/defines/env'
import { miniProgramEnv } from '@/defines/environment'

function assertHasMpSDK(target, name, descriptor) {
  const func = descriptor.value
  descriptor.value = function () {
    const hasJSSDK =
      (miniProgramEnv.isWechatMiniProgram && window.wx) ||
      (miniProgramEnv.isAlipayMiniProgram && window.my)
    if (hasJSSDK) {
      return func.apply(this, arguments)
    } else {
      NODE_ENV === 'development' &&
        console.warn(
          '尽管你在小程序 Webview 中，但是 window.wx 或 window.my 不存在。'
        )
    }
  }
}

class MpsCombination {
  @assertHasMpSDK
  switchTab() {
    switch (true) {
      case miniProgramEnv.isWechatMiniProgram:
        window.wx.miniProgram.switchTab(...arguments)
        break
      case miniProgramEnv.isAlipayMiniProgram:
        window.my.switchTab(...arguments)
        break
    }
  }

  @assertHasMpSDK
  navigateTo() {
    switch (true) {
      case miniProgramEnv.isWechatMiniProgram:
        window.wx.miniProgram.navigateTo(...arguments)
        break
      case miniProgramEnv.isAlipayMiniProgram:
        window.my.navigateTo(...arguments)
        break
    }
  }

  @assertHasMpSDK
  postMessage() {
    switch (true) {
      case miniProgramEnv.isWechatMiniProgram:
        window.wx.miniProgram.postMessage(...arguments)
        break
      case miniProgramEnv.isAlipayMiniProgram:
        window.my.postMessage(...arguments)
        break
    }
  }

  @assertHasMpSDK
  navigateBack() {
    switch (true) {
      case miniProgramEnv.isWechatMiniProgram:
        window.wx.miniProgram.navigateBack(...arguments)
        break
      case miniProgramEnv.isAlipayMiniProgram:
        window.my.navigateBack(...arguments)
        break
    }
  }
}

export const mpsCombination = new MpsCombination()
